import { render, staticRenderFns } from "./Occupancy.vue?vue&type=template&id=9d4c2e82&"
import script from "./Occupancy.vue?vue&type=script&lang=js&"
export * from "./Occupancy.vue?vue&type=script&lang=js&"
import style0 from "./Occupancy.vue?vue&type=style&index=0&id=9d4c2e82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QCard,Scroll} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QCard})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Scroll})
